import type { Capability } from '@taler/api-client'

/** No dedicated forecast capability exists; a scenario is a financial record like a target or a loan. */
export function canViewForecast(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
